<template>
  <div>
    <h5 class="my-3">Tipo de usuario y permisos</h5>
    <b-row>
      <b-col cols="12">
        <b-form-group
        horizontal
        :label-cols="2"
        label="Tipo de usuario"
        :invalid-feedback="!state.userType ? 'Debe seleccionar un tipo de usuario' : ''"
        :state="state.userType">
          <b-form-select
            v-model="user.userType"
            :options="userTypeOptions"
            @change="restartOptions"
            >
            <option slot="first" :value="null" :disabled="true">Seleccione un tipo de usuario</option>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="12" class="mt-3" v-if="user.userType && user.userType !== 'CATALOGER_USER'">
        <b-form-group
            horizontal
            :label-cols="2"
            label="Permisos"
        >
          <div
            v-for="(roleOption, index) in roleOptions"
            :key="index"
          >
            <b-form-checkbox
              v-model="user.roles"
              :value="roleOption"
              :disabled="!user.userType"
            >
              {{ formatRoleName(roleOption.roleName) }}
            </b-form-checkbox>
          </div>
        </b-form-group>
      </b-col>
      <b-col md="12" class="mt-2" v-if="user.userType">
        <b-form-group
          horizontal
          :label-cols="2"
          :label="$t('Sellers')"
          :description="!['ADMIN_USER', 'CATALOGER_USER'].includes(user.userType) ? $t('Solo el usuario administrador logistico puede seleccionar mas de un Seller') : ''"
          :invalid-feedback="!state.sellers? $t('Debe seleccionar al menos un seller') : ''"
          :state="state.sellers">
          <b-form-checkbox
            v-if="user.userType === 'LOGISTICS_ADMIN'"
            v-model="selectAllSellers"
            @change="toggleSelectAllSellers"
          >
            Asignarle todos los sellers
          </b-form-checkbox>
          <autocomplete
            v-if="showAutocomplete"
            id="inputSellers"
            class="input_class optional"
            name="inputSellers"
            :maxElements="user.userType && user.userType === 'LOGISTICS_ADMIN' ? 100 : 1"
            :disabled="!isAdmin"
            :searchText="$t('Enter para agregar Seller')"
            :provider="getSearchSeller"
            v-model="user.organizations"
            :seletecAll="true">
          </autocomplete>
          <span v-if="['ADMIN_USER', 'CATALOGER_USER'].includes(user.userType)" class="disclaimer">Se asignarán todos los sellers para este tipo de usuario.</span>
        </b-form-group>
      </b-col>
    </b-row>
    <div class="disclaimer mb-3">
      <ul>
        <li><strong>{{$t('Administrador Marketplace')}}:</strong> {{$t('Permite generar nuevos usuarios, tanto Administradores como Sellers. Los permisos')}} <i>"{{$t('Administrador Seller')}}"</i> {{$t('están contenidos en este rango')}}.</li>
        <li><strong>{{$t('Administrador Logístico')}}:</strong> {{$t('Permite la actividad logistica limitada segun sus permisos, como devolver productos.')}} </li>
        <li><strong>{{$t('Administrador Seller')}}:</strong> {{$t('Permite generar nuevos usuarios Sellers, sólo habilita a generar nuevos usuarios del tipo seller. Los permisos')}} <i>"{{$t('Seller')}}"</i> {{$t('están contenidos en este rango')}}.</li>
        <li><strong>{{$t('Seller')}}:</strong> {{$t('Permite generar nuevos productos y activar nuevos SKUs, sólo habilita a generar nuevos usuarios del tipo seller.')}}</li>
        <li><strong>{{$t('Catalogador')}}:</strong> {{$t('Permite la gestión de productos, precios, inventario y promociones.')}}</li>
      </ul>
    </div>
  </div>
</template>
<script>
import { OrganizationService } from '@/mixims/AdminServiceMixin'
import autocomplete from '@/components/common/vue-autocomplete'

export default {
  mixins: [OrganizationService],
  components: { autocomplete },
  props: ['user', 'state', 'roles'],
  data () {
    return {
      selectAllSellers: this.user.userType === 'LOGISTICS_ADMIN' && this.user.organizations.length === 0,
      isAdmin: this.$store.getters.isAdmin,
    }
  },
  methods: {
    restartOptions () {
      this.$emit('emitUpdateUser', {
        ...this.user,
        roles: [],
        organizations: this.$store.getters.isAdmin ? [] : this.$store.state.user_data.organizations
      });
    },
    toggleSelectAllSellers() {
      this.selectAllSellers = !this.selectAllSellers
      this.$emit('emitAllSellersToggle', this.selectAllSellers)
      if (this.selectAllSellers) {
        this.user.organizations = []
      }
    },
    formatRoleName (roleName) {
      switch (roleName) {
        case 'INVENTORY_USER':
          return 'Inventario'
        case 'CARRIERS_USER':
          return 'Transportadoras'
        case 'CATALOG_USER':
          return 'Catálogo'
        case 'ORDERS_USER':
          return 'Pedidos'
        case 'REPORTS_USER':
          return 'Reportes'
      }
    }
  },
  computed: {
    userTypeOptions () {
      let userTypes = [
        { value: 'ORGANIZATION_ADMIN_USER', text: 'Seller Administrador' },
        { value: 'ORGANIZATION_STANDARD_USER', text: 'Seller' },
      ]
      if (this.$store.getters.isAdmin) {
        userTypes.unshift({ value: 'CATALOGER_USER', text: 'Catalogador' })
        userTypes.unshift({ value: 'LOGISTICS_ADMIN', text: 'Administrador Logístico' })
        userTypes.unshift({ value: 'ADMIN_USER', text: 'Administrador Marketplace' })
      }
      return userTypes
    },
    roleOptions() {
      const rolesMap = {
        'ORGANIZATION_ADMIN_USER': [
          { roleName: 'INVENTORY_USER', id: 'INVENTORY_USER', description: 'Has inventory right' },
          { roleName: 'CARRIERS_USER', id: 'CARRIERS_USER', description: 'Has carriers right' },
          { roleName: 'CATALOG_USER', id: 'CATALOG_USER', description: 'Has catalog right' }
        ],
        'ORGANIZATION_STANDARD_USER': [
          { roleName: 'INVENTORY_USER', id: 'INVENTORY_USER', description: 'Has inventory right' },
          { roleName: 'CARRIERS_USER', id: 'CARRIERS_USER', description: 'Has carriers right' },
          { roleName: 'CATALOG_USER', id: 'CATALOG_USER', description: 'Has catalog right' }
        ],
        'ADMIN_USER': [
          { roleName: 'CARRIERS_USER', id: 'CARRIERS_USER', description: 'Has carriers right' },
          { roleName: 'CATALOG_USER', id: 'CATALOG_USER', description: 'Has catalog right' }
        ]
      }

      let roles = [
        { roleName: 'ORDERS_USER', id: 'ORDERS_USER', description: 'Has order right' },
        { roleName: 'REPORTS_USER', id: 'REPORTS_USER', description: 'Has report right' }
      ]

      if(this.user.userType == 'CATALOGER_USER') {
        return []
      }

      if(this.user.userType == 'LOGISTICS_ADMIN') {
        roles.push({ roleName: 'CATALOG_USER', id: 'CATALOG_USER', description: 'Has catalog right' })
      }

      return roles.concat(rolesMap[this.user.userType] || [])
    },
    showAutocomplete() {
      return this.user.userType &&
      !['ADMIN_USER', 'CATALOGER_USER'].includes(this.user.userType) &&
      (this.user.userType !== 'LOGISTICS_ADMIN' || !this.selectAllSellers)
    },
  },
  watch: {
    'user.organizations': function(newVal, oldVal) {
      this.selectAllSellers = newVal.length === 0;
      this.$emit('emitAllSellersToggle', this.selectAllSellers)
    },
    'user.userType': function(newVal, oldVal) {
      if (newVal === 'LOGISTICS_ADMIN' &&  this.user.organizations.length > 50) {
        this.selectAllSellers = this.user.organizations.length === 0
        this.selectAllSellers = true
        this.user.organizations = []
      } else {
        this.selectAllSellers = false;
      } if (['ADMIN_USER', 'CATALOGER_USER'].includes(newVal)) {
        this.user.organizations = []
      }
    },
  },
  mounted () {
    if (['ADMIN_USER', 'CATALOGER_USER'].includes(this.user.userType)) {
      this.user.organizations = []
    }
    if (this.user.userType === 'LOGISTICS_ADMIN' && this.user.id && this.user.organizations.length > 50) {
      this.user.organizations = []
    }
  }
}
</script>

<style lang="scss" scoped>
  .disclaimer {
    background-color: #f5f3f3;
    border-radius: 5px;
    margin-top: 20px;
    padding: 10px 25px;

    ul {
      list-style: none;
      padding: 0;

      li {
        color: #777777;
        font-size: 10px;
      }
    }
  }
</style>